import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InputAdornment } from '@mui/material';

import { maxValueOfTotalAmount } from '../../../constants/constants';

import AutoSaveTextField from '../../AutoSaveTextField';

const UpdateTotalAmountInputComponent = ({ value, disabled, handleUpdate, onFormChange }) => {
    const { t } = useTranslation();

    const [isError, setIsError] = useState(false);

    const handleBlur = event => {
        const raw = event.target.value;

        if (raw === '') {
            setIsError(true);
            onFormChange?.({ quantityData: { defected: value?.defected, total: null } });
            return;
        }

        setIsError(false);

        handleUpdate('basicInformation', {
            basicInformation: {
                quantityData: {
                    total: Math.min(+raw, maxValueOfTotalAmount),
                    defected: value?.defected,
                },
            },
        });
    };

    return (
        <AutoSaveTextField
            required
            error={isError || value?.total == null || value?.total === ''}
            onlyPositiveDigits
            value={value?.total}
            disabled={disabled}
            type="number"
            fullWidth
            onBlur={handleBlur}
            onKeyPress={event => {
                event.key === 'Enter' && handleBlur(event);
            }}
            label={t('report.form.totalAmount')}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <span>Pcs</span>
                    </InputAdornment>
                ),
            }}
        />
    );
};

const UpdateTotalAmountInput = memo(UpdateTotalAmountInputComponent);

export default UpdateTotalAmountInput;
